import "./Home.css";

function Home() {
  return (
    <header class="Home-header">This website is under construction!!!</header>
  );
}

export default Home;
